import React, { useEffect, useState } from "react";
import {
  FooterContainer,
  FooterLinksItems,
  FooterLinkedinIcon,
  FooterGithubinIcon,
  FooterLinkMedia,
  FooterLinkIcon,
  SocialIcon,
  SocialLogo,
  SocialMedia,
  SocialMediaWrap,
  BottomToTopButton,
  WebSiteRights,
} from "./Footer.elements";
import logo from "../../images/logoPersonal.png";
import { AiOutlineArrowUp } from "react-icons/ai";
import Aos from "aos";
import "aos/dist/aos.css";

export default function Footer({ light }) {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  const [active, setactive] = useState(false);

  window.addEventListener("scroll", () => {
    if (window.scrollY > 0) {
      setactive(true);
    } else {
      setactive(false);
    }
  });

  const scrollUp = () => {
    window.scroll({ top: 0, behavior: "smooth" });
  };
  return (
    <>
      <FooterContainer light={light}>
        <SocialMedia>
          <SocialMediaWrap>
            <SocialLogo href="#home" light={light}>
              <SocialIcon src={logo} light={light} />
              Web Personal
            </SocialLogo>
            <WebSiteRights light={light}>
              Alonso Díaz Sobrino © Copyright 2021
            </WebSiteRights>
            <FooterLinksItems>
              <FooterLinkMedia>
                <FooterLinkIcon
                  light={light}
                  href={
                    "https://www.linkedin.com/in/alonso-diaz-sobrino-424b68226/"
                  }
                  target="_blank"
                  aria-label="Linkedin"
                >
                  <FooterLinkedinIcon />
                </FooterLinkIcon>
                <FooterLinkIcon
                  light={light}
                  href={"https://github.com/alonsodiaxz"}
                  target="_blank"
                  aria-label="Github"
                >
                  <FooterGithubinIcon />
                </FooterLinkIcon>
              </FooterLinkMedia>
            </FooterLinksItems>
          </SocialMediaWrap>
        </SocialMedia>
      </FooterContainer>
      {active ? (
        <BottomToTopButton onClick={scrollUp} className="bottomToUp">
          <AiOutlineArrowUp />
        </BottomToTopButton>
      ) : (
        ""
      )}
    </>
  );
}
